export default __webpack_public_path__ + "static/media/img_tutor_howitworks_01@small.ac906a26.png";